const filterKey = {
  ACCOUNT: "account",
  AGENT_ACCOUNT: "agent_account",
  LEVEL: "level",
};

export { filterKey };
